import { captureException } from '@sentry/browser'

import { Injectable } from '@angular/core'

import { TranslationService } from '@lemon/core-firebase/service/translation.service'
import { TuettuKieli } from '@lemon/core/model/common'

import { BehaviorSubject, Observable } from 'rxjs'

@Injectable()
export class LemonTranslationService {
  private currentLanguageSubject: BehaviorSubject<TuettuKieli> = new BehaviorSubject<TuettuKieli>('fi')
  currentLanguageObservable: Observable<TuettuKieli> = this.currentLanguageSubject.asObservable()

  constructor(private translationService: TranslationService) {}

  public lokalisoi(avain: string, parametrit?: any): string {
    return this.translationService.lokalisoi(avain, this.currentLanguageSubject.value, parametrit)
  }

  public lokalisoiKielella(avain: string, kieli: TuettuKieli, parametrit?: any): string {
    return this.translationService.lokalisoi(avain, kieli, parametrit)
  }

  public get nykyinenKieli(): TuettuKieli {
    return this.currentLanguageSubject.value
  }

  public vaihdaKieli(kieli: TuettuKieli) {
    if (kieli && this.currentLanguageSubject.value !== kieli) {
      this.currentLanguageSubject.next(kieli)
    }
  }

  /** Kirjautumattomana (kirjautumissivuilla) tehty valinta, joka viedään käyttäjän asiointikieleksi kirjautumisen jälkeen. */
  private _kirjautumattomanValinta: TuettuKieli | null = null

  public merkitseKirjautumattomanValinta(kieli: TuettuKieli) {
    this._kirjautumattomanValinta = kieli
  }

  /** Palauttaa ja nollaa kirjautumattomana tehdyn valinnan. */
  public otaKirjautumattomanValinta(): TuettuKieli | null {
    const valinta = this._kirjautumattomanValinta
    this._kirjautumattomanValinta = null
    return valinta
  }
  getSupportedLocale(suspect: string): TuettuKieli {
    if (suspect === 'fi') {
      return 'fi'
    }
    if (suspect === 'en') {
      return 'en'
    }
    // if (suspect === 'sv') {
    //   return 'sv'
    // }
    captureException(new Error(`No support for locale ${suspect}`))
    return 'fi'
  }
}
